import {Component, OnDestroy} from '@angular/core';
import {Subject} from 'rxjs';

@Component({
  template: '',
})
export class BaseComponent implements OnDestroy {
  protected destroy$ = new Subject<void>();

  /**
   * Lifecycles
   */
  ngOnDestroy(): void {
    this.dispose();
  }

  dispose(): void {
    if (this.destroy$.next) {
      this.destroy$.next();
      this.destroy$.complete();
    }
  }
}
